import { ErrorInterface } from '../../interfaces/general.interface';
import { AuthUserEntityInterface } from '../../interfaces/auth.interface';

export interface AuthUserState {
  entity: AuthUserEntityInterface | null;
  error: boolean | ErrorInterface;
  loading: boolean;
  success: boolean;
  redirect: 'admin' | true | false;
}

export const initialAuthState: AuthUserState = {
  entity: null,
  error: false,
  loading: true,
  success: false,
  redirect: false,
};
